import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import '../../App.css';
import TableContainer from '@mui/material/TableContainer';
import { Styles, StyleConstants } from '../../Styles';

const CarAirConditioningSystemTab = (props) => {
    const { packet } = props;

    const getOperationMode = (hexValueStr) => {
        let operationMode = '';

        switch (hexValueStr) {
            case '00':
                operationMode = 'OFF';
                break;
            case '01':
                operationMode = 'Test Cool';
                break;
            case '11':
                operationMode = 'Vent High';
                break;
            case '12':
                operationMode = 'Vent Low';
                break;
            case '21':
                operationMode = 'Cool 1';
                break;
            case '22':
                operationMode = 'Cool 2';
                break;
            default:
        }

        return operationMode;
    }

    return (
        <>
            {(packet.board1 !== null) && (
                <TableContainer component={Paper}>
                    <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                        <TableHead>
                            <TableRow sx={{ '& th': { color: '#FFFFFF', backgroundColor: StyleConstants.mainBgColor } }}>
                                <TableCell>Air Conditioning (A/C)</TableCell>
                                <TableCell sx={{...Styles.carBorderCell, width: '100px'}}>
                                    Unit 1
                                </TableCell>
                                <TableCell sx={{...Styles.carBorderCell, width: '100px'}}>
                                    Unit 2
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell>Return Air Temperature</TableCell>
                                <TableCell sx={Styles.carBorderCellRight}>
                                    {packet.board1.vac.unitNo1AirTemp} °C
                                </TableCell>
                                <TableCell sx={Styles.carBorderCellRight}>
                                    {packet.board1.vac.unitNo2AirTemp} °C
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell>Operaton Mode</TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    {getOperationMode(packet.board1.vac.unitNo1OpMode)}
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    {getOperationMode(packet.board1.vac.unitNo2OpMode)}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell>Set Point Temperature</TableCell>
                                <TableCell sx={Styles.carBorderCellRight}>
                                    {packet.board1.vac.unitNo1SetTemp} °C
                                </TableCell>
                                <TableCell sx={Styles.carBorderCellRight}>
                                    {packet.board1.vac.unitNo2SetTemp} °C
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
};

export default CarAirConditioningSystemTab;